import React, { useState, useEffect } from 'react';
import api from '../../../services/api';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const TeamPreview = ({ isAdminPreview = true }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const res = await api.get('/business/team/');
      setMembers(res.data || []);
    } catch (err) {
      console.error('Error fetching team:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    if (isAdminPreview) {
      const interval = setInterval(fetchData, 2000);
      return () => clearInterval(interval);
    }
  }, [isAdminPreview]);

  if (loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!members.length) {
    return (
      <div style={{
        padding: '2rem',
        textAlign: 'center',
        color: 'rgba(255,255,255,0.5)',
        backgroundColor: '#0f172a',
        minHeight: '200px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        No team members added yet.
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', backgroundColor: '#0f172a', minHeight: '200px' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: '700', color: '#fff', textAlign: 'center', marginBottom: '1.5rem' }}>
        Our Team
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '1rem'
      }}>
        {members.slice(0, 6).map((member, index) => (
          <div
            key={member.id || index}
            style={{
              textAlign: 'center',
              padding: '1rem',
              backgroundColor: 'rgba(255,255,255,0.05)',
              borderRadius: '0.75rem'
            }}
          >
            <div style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              overflow: 'hidden',
              margin: '0 auto 0.75rem',
              border: '2px solid rgba(99, 102, 241, 0.3)'
            }}>
              {member.photo || member.image ? (
                <img
                  src={buildMediaUrl(member.photo || member.image)}
                  alt={member.name}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  backgroundColor: '#334155',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#94a3b8',
                  fontSize: '1.5rem',
                  fontWeight: '600'
                }}>
                  {member.name?.charAt(0)?.toUpperCase() || '?'}
                </div>
              )}
            </div>
            <h3 style={{ color: '#fff', fontSize: '0.8rem', fontWeight: '600' }}>
              {member.name}
            </h3>
            {member.role && (
              <p style={{ color: '#6366f1', fontSize: '0.7rem' }}>
                {member.role}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamPreview;
